import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, filter } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { User } from '../models/user.model';
import { ResponsePackage } from '../models/util.model';
import { SystemComponents } from '../models/role.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
    providedIn: 'root'
  })
export class UserService {
    
  private pathApi: string;
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
      this.pathApi = this.config.pathApi + "user/";
  }
  
  getUsersForFilter(type: SystemComponents): Observable<any> {
    return this.http.get(`${this.pathApi}getUsersForFilter?userType=${type}`);
  }

  getMobileUsers(areaId?: number, filterText?: string) {
  let params = new HttpParams();

  if (areaId !== undefined && areaId !== null) {
    params = params.set('areaId', areaId.toString());
  }

  if (filterText) {
    params = params.set('filterText', filterText);
  }

  return this.http.get<ResponsePackage<User[]>>(
    `${this.pathApi}getFieldAgents`,
    { params, observe: 'response' }
  );
}

  forgotPasswordRequest(email: any): Observable<any> {
    return this.http.post(
      `${this.pathApi}forgotPasswordRequest`,
      { email: email }
    );
  }

  validateResetCode(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}validateResetCode`, obj);
  }

  resetPassword(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}resetPassword`, obj);
  }
}